import { render } from "./DetailShop.vue?vue&type=template&id=581e17df&scoped=true"
import script from "./DetailShop.vue?vue&type=script&lang=js"
export * from "./DetailShop.vue?vue&type=script&lang=js"

import "./DetailShop.vue?vue&type=style&index=0&id=581e17df&scoped=true&lang=css"

import exportComponent from "/home/jacques/development/kvhbf/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581e17df"]])

export default __exports__